var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultitrack = function SvgMultitrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 45,
    viewBox: "0 0 55 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f4f9",
    d: "M15.982 44.304c-5.374 0-9.73-4.357-9.73-9.73v-9.109a9.73 9.73 0 0 1 9.73-9.73h29.035a9.73 9.73 0 0 1 9.73 9.73v9.108a9.73 9.73 0 0 1-9.73 9.73z",
    className: "shadow"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M41.145 12.503c4.19 0 7.6 3.41 7.6 7.6V30.7c0 4.19-3.41 7.601-7.6 7.601H10.62c-4.19 0-7.6-3.41-7.6-7.6V20.103c0-4.191 3.41-7.601 7.6-7.601zM51.516 30.7V20.104c0-5.72-4.652-10.372-10.371-10.372H10.62C4.901 9.732.25 14.385.25 20.104V30.7c0 5.72 4.651 10.372 10.37 10.372h30.525c5.719 0 10.371-4.653 10.371-10.372M40.824 7.985H10.941a1.386 1.386 0 0 1 0-2.77h29.883a1.385 1.385 0 1 1 0 2.77M34.387 3.466H17.378a1.385 1.385 0 1 1 0-2.77h17.009a1.386 1.386 0 0 1 0 2.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "m31.323 25.401-9.752 4.944V20.46zm-10.511 8.433 14.2-7.197a1.385 1.385 0 0 0 0-2.471l-14.2-7.197a1.384 1.384 0 0 0-2.011 1.236v14.394a1.386 1.386 0 0 0 2.01 1.235z"
  })));
};
export default SvgMultitrack;